module.exports = __webpack_public_path__ + "img/expand.3ed8f8f8.svg";